import { FormGroup, Label } from 'flos-react-cvi';
import React from 'react';

export class DateField extends React.Component {
    fieldRef = React.createRef();

    onEvent = event => {
        const { onChangeValue } = this.props;

        if (
            event.detail.event === 'onChange' &&
            onChangeValue &&
            event.detail.value !== this.props.value &&
            event.detail.result
        ) {
            onChangeValue(event.detail.value);
        }
    };

    componentDidMount() {
        this.fieldRef.current.addEventListener('fieldEvent', this.onEvent);
    }

    componentWillUnmount() {
        this.fieldRef.current.removeEventListener('fieldEvent', this.onEvent);
    }

    render() {
        const { value, minDate, maxDate, status, label, required, id } = this.props;

        return (
            <FormGroup status={status} required={required}>
                {label && <Label htmlFor={id}>{label}</Label>}
                <flos-date-input
                    ref={this.fieldRef}
                    input-id={id}
                    value={value}
                    min-date={minDate}
                    max-date={maxDate}
                />
            </FormGroup>
        );
    }
}
